/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Review_NoInputs */

const en_ticket_review_no = /** @type {(inputs: Ticket_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const ja_ticket_review_no = /** @type {(inputs: Ticket_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const fr_ticket_review_no = /** @type {(inputs: Ticket_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_ticket_review_no = /** @type {(inputs: Ticket_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Ticket_Review_NoInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_review_no = /** @type {((inputs?: Ticket_Review_NoInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Review_NoInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_review_no(inputs)
	if (locale === "ja") return ja_ticket_review_no(inputs)
	if (locale === "fr") return fr_ticket_review_no(inputs)
	return de_ticket_review_no(inputs)
});